import { StoreLocation } from '../../templates/components/localisation/utils/types';
import Cookies from 'js-cookie';
import { AlgoliaApiClient } from '../../api/localisation/AlgoliaApiClient';
import { DeliveryLocation } from '../../templates/components/localisation/utils/types';

export const LOCATION_PERMISSION_COOKIE = 'LocationPermissionRequested';

export const STORE_LOCATIONS = {
  AU: 'AU',
  NZ: 'NZ',
} as const;

export const STORE_LOCATIONS_COORDS = {
  [STORE_LOCATIONS.AU]: {
    lat: -28,
    lng: 135,
  },
  [STORE_LOCATIONS.NZ]: {
    lat: -36.848461,
    lng: 174.763336,
  },
};

const userLocation = {
  coordinates: {
    lat: 0,
    lng: 0,
  },
  userPermission: false,
};

export const getUserLocation = (): Promise<Array<DeliveryLocation>> => {
  const { localisationCookieExpiryInDays } = window.Jbhifi.localisationSettings;
  const midnight = new Date();
  midnight.setDate(midnight.getDate() + localisationCookieExpiryInDays || 0);
  midnight.setHours(23, 59, 59, 999);
  Cookies.set(LOCATION_PERMISSION_COOKIE, 'true', { expires: midnight });
  return new Promise(resolve => {
    navigator.geolocation.getCurrentPosition(
      async pos => {
        userLocation.coordinates.lat = pos.coords.latitude;
        userLocation.coordinates.lng = pos.coords.longitude;
        userLocation.userPermission = true;

        const approximateLocation = userLocation.userPermission
          ? { latitude: userLocation.coordinates.lat, longitude: userLocation.coordinates.lng }
          : undefined;
        if (approximateLocation) {
          const result: Array<DeliveryLocation> = await AlgoliaApiClient.getLocations({
            body: '',
            approximateLocation,
            hitsPerPage: 1,
            aroundLatLngViaIP: !userLocation.userPermission,
          });
          resolve(result);
        }
      },
      err => {
        console.error('Error in getting geolocation', err);
        window.appInsights?.trackEvent({
          name: 'Geolocation Error',
          properties: {
            code: err.code.toString(),
            message: err.message,
          },
        });
        userLocation.userPermission = false;
        resolve([]);
      }
    );
  });
};

const R = 6371; // km

export const getDistance = (
  locationA: { latitude: number; longitude: number } | undefined,
  locationB: { lat: number; lng: number } | undefined
) => {
  if (locationA && locationB) {
    const { latitude: lat1, longitude: lon1 } = locationA;
    const { lat: lat2, lng: lon2 } = locationB;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = (R * c).toFixed(2);

    return d;
  }
};

export const getStoreLink = (storeName: string) => {
  storeName = storeName.toLowerCase();
  const toReplace = ['"', "'", '\\', '(', ')', '[', ']'];

  // For the old browsers
  for (let i = 0; i < toReplace.length; ++i) {
    storeName = storeName.replace(toReplace[i], '').trim();
  }
  storeName = storeName.replace(/\W+/g, '-');
  if (storeName.charAt(storeName.length - 1) == '-') {
    storeName = storeName.replace(/-+z/, '');
  }
  if (storeName.charAt(0) == '-') {
    storeName = storeName.replace(/A-+/, '');
  }
  return storeName;
};

export const getStoreLocationIslandNZ = (storePostCode: string) => {
  return Number(storePostCode) > 6999 ? 'South Island' : 'North Island';
};

export const getStoreLocation = (store: StoreLocation) => {
  const storeCode =
    window.Jbhifi.storeLocation === STORE_LOCATIONS.AU ? store?.state : getStoreLocationIslandNZ(store?.postcode);
  return storeCode || '';
};
